export enum CareTypeCode {
    // Regular subtrack (DBC)
    ZT11 = '11',

    // Regular subtrack continuation (DBC)
    ZT21 = '21',

    // OZP
    ZT41 = '41',
}

export function isCareTypeCode(value: string | null): value is CareTypeCode {
    return Object.values(CareTypeCode).includes(value as CareTypeCode);
}

export function stringToCareTypeCode(value: string | null): CareTypeCode {
    if (!isCareTypeCode(value)) {
        throw new Error(`Invalid CareTypeCode: ${value}`);
    }

    return value as CareTypeCode;
}
